export enum Service {
    LIKES = 'likes',
    BEAUTY = 'beauty',
}
export const services = [Service.LIKES, Service.BEAUTY];

export function currentService(): Service {
    if (!location || !location.pathname) {
        return Service.LIKES;
    }
    const path = location.pathname;
    return path.split('/')[2] as Service;
}
